module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', [(_vm.error_num) ? _c('div', [_c('main_panel', {
    ref: "main_panel"
  })], 1) : _c('div', [_c('div', {
    staticStyle: {
      "text-align": "center",
      "padding": "20px"
    }
  }, [_c('img', {
    staticStyle: {
      "vertical-align": "middle",
      "width": "200px",
      "height": "200px"
    },
    attrs: {
      "src": _vm.errorpage
    }
  }), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('span', {
    staticStyle: {
      "color": "#6A676F",
      "font-size": "25px",
      "font-weight": "bold"
    }
  }, [_vm._v("哇哦！数据请求失败")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?{"id":"data-v-6e3dbf5c","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = qeOq
// module chunks = 81